import {createSelector} from 'reselect'
import {isProcessingBulkOperation} from '../bulkOperations/selectors'
import {getCommonState} from '../common/selectors'

export const isShowLoadingMoire = createSelector(
    getCommonState,
    isProcessingBulkOperation,
    (common, bulkProcessing) => common.showLoadingMoire || bulkProcessing
)


// WEBPACK FOOTER //
// ./web/js/taskManagement/loadingMoire/selectors.js